(function adminNotificationConfigDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminNotificationConfigService', [
            'restUrlBuilder', 'authExtend', function adminNotificationService(restUrlBuilder, authExtend) {

                this.getById = function getById(id) {
                    return restUrlBuilder.one('adminNotificationConfig', id).get();
                };

                this.create = function notificationConfigCreate(notification) {
                    if (notification === null)
                        throw "La configuración de notificación no puede ser null";

                    return restUrlBuilder.all('adminNotificationConfig')
                        .post(notification);
                };

                this.update = function notificationConfigUpdate(notification) {
                    if (notification === null)
                        throw "La configuración de notificación no puede ser null";

                    return restUrlBuilder.all('adminNotificationConfig')
                        .put(notification);
                };

                this.delete = function deleteNotif(id) {
                    return restUrlBuilder.one('adminNotificationConfig', id).delete();
                };

                this.get = function get(name, templateName, documentTypeId, roleId, organizationalUnitId) {

                    var params = { Name: name, TemplateName: templateName, DocumentTypeId: documentTypeId, RoleId: roleId, OrganizationalUnitId: organizationalUnitId };

                    return restUrlBuilder.all('adminNotificationConfig')
                        .get({ params: params });
                };

            }
        ]);
})();